export default __webpack_public_path__ + "8be977416a886642b62519c88952cc4a.svg";